import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getGradebookInstructor,
  updateShowPercentageCourseSettings,
} from '../../../../actions/gradebook';
import { getGradebook } from '../../../../actions/getGradebook';
import { togglePointOrGrade } from '../../../../actions/analyticsEvents';
import { selectShowPercent } from '../../../../selectors/settings';
import MLButtonToggle from '../../../MLButtonToggle/MLButtonToggle';

const handleOnClick = async (
  dispatch,
  courseId,
  sendEvent,
  showPercent,
  isGradebookV2Active,
) => {
  await dispatch(updateShowPercentageCourseSettings(courseId, showPercent));
  dispatch(sendEvent(togglePointOrGrade(courseId, showPercent ? '%' : 'pts')));
  if (isGradebookV2Active) {
    dispatch(getGradebookInstructor(courseId));
  } else {
    dispatch(getGradebook(courseId));
  }
};

const PointOrGradeToggleButton = ({
  dispatch,
  sendEvent,
  showPercent,
  courseId,
  isGradebookV2Active = false,
}) => (
  <MLButtonToggle
    btnText="%"
    btnTextSecondary="pts"
    btnType={showPercent ? 'primary' : 'secondary'}
    onClick={() =>
      handleOnClick(dispatch, courseId, sendEvent, true, isGradebookV2Active)
    }
    btnTypeSecondary={!showPercent ? 'primary' : 'secondary'}
    onClickSecondary={() =>
      handleOnClick(dispatch, courseId, sendEvent, false, isGradebookV2Active)
    }
  />
);

PointOrGradeToggleButton.propTypes = {
  dispatch: PropTypes.func.isRequired,
  sendEvent: PropTypes.func.isRequired,
  showPercent: PropTypes.bool.isRequired,
  courseId: PropTypes.string.isRequired,
  isGradebookV2Active: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    showPercent: selectShowPercent(state),
    courseId: state.gradebook.courseId,
  };
}

export default connect(mapStateToProps)(PointOrGradeToggleButton);
